import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import React, { useState } from "react";
import styles from "./Login.module.css";

import { useDispatch } from "react-redux";
import { addUser } from "../../redux/rtk/features/user/userSlice";

import { Navigate } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import LoginTable from "../Card/LoginTable";
import loginImg from "../../assets/images/login-page.jpg";
import logo from "../../assets/images/resqroom-dark-logo.png"

const Login = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const { Title } = Typography;
  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (isLogged) {
    return <Navigate to={"/admin/franchises"} replace={true} />;
  }
  const onFinish = async (values) => {
    const resp = await dispatch(addUser(values));
    if (resp.payload.message === "success") {
      setLoader(false);
      window.location.href = "admin/franchises";
    } else {
      setLoader(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoader(false);
    toast.error("Error at login Please try again");
  };

  return (
    <>
      <div className='lg:ms-[-240px] card-row h-[85vh] lg:h-screen mt-[-16px] bg-[#F2F2F2]'>
        <div className=' login-wrapper h-full'>
          <div className="w-full flex justify-center flex-col items-center lg:mt-0 p-4 h-full">
            <img src={logo} className="mb-4 h-12 w-auto"/>
            <Card bordered={false}
              className='rounded-lg w-full lg:w-1/3'>
              <Title level={3} className='my-3text-start'>
                  Sign in to your account
              </Title>
              <Form
                name='basic'
                wrapperCol={{
                  span: 24,
                }}
                labelCol={{
                  span: 24,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete='off'
                className=""
              >
                <Form.Item
                  className='mb-6 text-start form-item-alignment username'
                  label='Username'
                  name='userName'
                  rules={[
                    {
                      required: true,
                      message: "Please input your userName!",
                    },
                  ]}
                >
                  <Input placeholder="Enter Username or Email" className="username-field h-[40px] bg-[#f9fafb] rounded-[0.7rem]" />
                </Form.Item>

                <Form.Item
                  className='mb-6 form-item-alignment password'
                  label='Password'
                  name='password'
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input.Password placeholder="Enter Password" className="pass-field pe-3 h-[40px] bg-[#f9fafb] rounded-[0.7rem]" />
                </Form.Item>
                {/* <Link
                  to={"/customer/forget-password"}
                  className='font-semibold text-danger text-end block mb-5 font-medium'
                >
                  Forgot password?
                </Link> */}
                <Form.Item>
                  <Button
                    type='primary'
                    htmlType='submit'
                    block
                    loading={loader}
                    onClick={() => setLoader(true)}
                    className="custom-filter-btn h-[40px] font-[600] rounded-[0.75rem]"
                  >
                    Sign In
                  </Button>
                </Form.Item>
                {/* <Form.Item >
                  <Row>
                    <Col span={24}>
                      <LoginTable username={"admin"} password={"admin"} />
                    </Col>
                  </Row>
                </Form.Item> */}
                
                {/* <h6 className='text-center mt-4'>
                  Don't have an account ?{" "}
                  <Link
                    to={"/customer/register"}
                    className='font-semibold text-indigo-600'
                  >
                    Register Here
                  </Link>
                </h6> */}
              </Form>
              {/* <div className="flex justify-center">
                <Link to={"/customer/login"} className='bg-teal-500 p-1 mt-3 w-2/6 rounded text-white font-semibold  block text-center'>
                  Customer login
                </Link>
              </div> */}
            </Card>
          </div>
        </div>
        {/* <div className="bg-[#0e0d12] py-5 text-center text-white">
          <p>ResQRoom © 2025. All Rights Reserved.</p>
        </div> */}
      </div>
    </>
  );
};

export default Login;
